// Copyright (c) 2016 Deere & Company

import CreateClaimModal, {getDefaultState} from '../state/create-claim-modal';
import actions from '../../product/actions-list';

const toggleCreateClaimModal = (state, action) =>
    CreateClaimModal.update(state, {
        $merge: {
            isModalOpen: action.isOpen,
            selectedPin: action.pin
        }
    });

const setClaimTypes = (state, action) =>
    CreateClaimModal.update(state, {
        claimTypes: {
            $set: action.claimTypes
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.SET_SEARCH_RESULT_CLAIM_TYPES]: setClaimTypes,
        [actions.TOGGLE_SEARCH_RESULT_CREATE_CLAIM_MODAL]: toggleCreateClaimModal
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/shared/reducers/create-claim-modal.js